import styles from './PageSpinner.module.css';

/**
 * A full-page loading state.
 *
 * `role="status"` with `aria-live="polite"` so a screen reader announces the
 * wait instead of landing on an apparently empty page.
 */
export function PageSpinner({ label = 'Loading' }: { label?: string }): React.JSX.Element {
  return (
    <div className={styles.wrapper} role="status" aria-live="polite">
      <span className={styles.spinner} aria-hidden="true" />
      <p className={styles.label}>{label}…</p>
    </div>
  );
}
